<template>
  <div class="home">
    This is the home page
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {

  }
};
</script>
